export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重置"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全选"])}
}